<template>
    <div v-if="0 < this.resources.length" class="card-resources">
        <h3 class="label-m content-1 card-resources-title">{{ this.title }}</h3>
        <div class="card-resources-container">
            <ResourceSpecsComponent v-for="(resource, index) in this.resources" 
                :key="index"
                :type="resource.type"
                :amount="resource.amount"
                :status="resource.status"
            />
        </div>
    </div>
</template>

<style scoped>
.card-resources {
    display: flex;
    padding: 8px 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
}

.card-resources-title {
    text-transform: uppercase;
}

.card-resources-container {
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    gap: 8px;
    align-self: stretch;
    flex-wrap: wrap;
    widows: 100%;
}
</style>

<script>
import ResourceSpecsComponent from '../core/ResourceSpecsComponent.vue';

export default {
    name: 'CardResourcesComponent',
    components: {
        ResourceSpecsComponent
    },
    props: {
        title: {
            type: String,
            required: true,
            default: 'Card Resources',
        },
        resources: {
            type: Array,
            required: true,
            default: () => [],
        }
    }
}
</script>